<template>
    <div class="iconcontainer">
    <div class="wrapper">
    <ul @click="clickul($event)">
    <li>
    <span class="icon iconfont" data-icon="&#xe616;">&#xe616;</span>
    </li>
    <li>
    <span class="icon iconfont" data-icon="&#xe617;">&#xe617;</span>
    </li>
    <li>
    <span class="icon iconfont" data-icon="&#xe618;">&#xe618;</span>
    </li>
    <li>
    <span class="icon iconfont" data-icon="&#xe619;">&#xe619;</span>
    </li>
    <li>
    <span class="icon iconfont" data-icon="&#xe61a;">&#xe61a;</span>
    </li>
    <li>
    <span class="icon iconfont" data-icon="&#xe61b;">&#xe61b;</span>
    </li>
    <li>
    <span class="icon iconfont" data-icon="&#xe61c;">&#xe61c;</span>
    </li>
    <li>
    <span class="icon iconfont" data-icon="&#xe61d;">&#xe61d;</span>
    </li>
    <li>
    <span class="icon iconfont" data-icon="&#xe61e;">&#xe61e;</span>
    </li>
    <li>
    <span class="icon iconfont" data-icon="&#xe61f;">&#xe61f;</span>
    </li>
    <li>
    <span class="icon iconfont" data-icon="&#xe620;">&#xe620;</span>
    </li>
    <li>
    <span class="icon iconfont" data-icon="&#xe621;">&#xe621;</span>
    </li>
    <li>
    <span class="icon iconfont" data-icon="&#xe622;">&#xe622;</span>
    </li>
    <li>
    <span class="icon iconfont" data-icon="&#xe623;">&#xe623;</span>
    </li>
    <li>
    <span class="icon iconfont" data-icon="&#xe624;">&#xe624;</span>
    </li>
    <li>
    <span class="icon iconfont" data-icon="&#xe625;">&#xe625;</span>
    </li>
    <li>
    <span class="icon iconfont" data-icon="&#xe626;">&#xe626;</span>
    </li>
    <li>
    <span class="icon iconfont" data-icon="&#xe627;">&#xe627;</span>
    </li>
    <li>
    <span class="icon iconfont" data-icon="&#xe628;">&#xe628;</span>
    </li>
    <li>
    <span class="icon iconfont" data-icon="&#xe629;">&#xe629;</span>
    </li>
    <li>
    <span class="icon iconfont" data-icon="&#xe62a;">&#xe62a;</span>
    </li>
    <li>
    <span class="icon iconfont" data-icon="&#xe62b;">&#xe62b;</span>
    </li>
    <li>
    <span class="icon iconfont" data-icon="&#xe62c;">&#xe62c;</span>
    </li>
    <li>
    <span class="icon iconfont" data-icon="&#xe62d;">&#xe62d;</span>
    </li>
    <li>
    <span class="icon iconfont" data-icon="&#xe62e;">&#xe62e;</span>
    </li>
    <li>
    <span class="icon iconfont" data-icon="&#xe62f;">&#xe62f;</span>
    </li>
    <li>
    <span class="icon iconfont" data-icon="&#xe630;">&#xe630;</span>
    </li>
    <li>
    <span class="icon iconfont" data-icon="&#xe631;">&#xe631;</span>
    </li>
    <li>
    <span class="icon iconfont" data-icon="&#xe632;">&#xe632;</span>
    </li>
    <li>
    <span class="icon iconfont" data-icon="&#xe633;">&#xe633;</span>
    </li>
    <li>
    <span class="icon iconfont" data-icon="&#xe634;">&#xe634;</span>
    </li>
    <li>
    <span class="icon iconfont" data-icon="&#xe635;">&#xe635;</span>
    </li>
    <li>
    <span class="icon iconfont" data-icon="&#xe636;">&#xe636;</span>
    </li>
    <li>
    <span class="icon iconfont" data-icon="&#xe637;">&#xe637;</span>
    </li>
    <li>
    <span class="icon iconfont" data-icon="&#xe638;">&#xe638;</span>
    </li>
    <li>
    <span class="icon iconfont" data-icon="&#xe639;">&#xe639;</span>
    </li>
    <li>
    <span class="icon iconfont" data-icon="&#xe63a;">&#xe63a;</span>
    </li>
    <li>
    <span class="icon iconfont" data-icon="&#xe63b;">&#xe63b;</span>
    </li>
    <li>
    <span class="icon iconfont" data-icon="&#xe63c;">&#xe63c;</span>
    </li>
    <li>
    <span class="icon iconfont" data-icon="&#xe63d;">&#xe63d;</span>
    </li>
    <li>
    <span class="icon iconfont" data-icon="&#xe63e;">&#xe63e;</span>
    </li>
    <li>
    <span class="icon iconfont" data-icon="&#xe63f;">&#xe63f;</span>
    </li>
    <li>
    <span class="icon iconfont" data-icon="&#xe640;">&#xe640;</span>
    </li>
    <li>
    <span class="icon iconfont" data-icon="&#xe641;">&#xe641;</span>
    </li>
    <li>
    <span class="icon iconfont" data-icon="&#xe642;">&#xe642;</span>
    </li>
    <li>
    <span class="icon iconfont" data-icon="&#xe643;">&#xe643;</span>
    </li>
    <li>
    <span class="icon iconfont" data-icon="&#xe644;">&#xe644;</span>
    </li>
    <li>
    <span class="icon iconfont" data-icon="&#xe645;">&#xe645;</span>
    </li>
    <li>
    <span class="icon iconfont" data-icon="&#xe646;">&#xe646;</span>
    </li>
    <li>
    <span class="icon iconfont" data-icon="&#xe647;">&#xe647;</span>
    </li>
    <li>
    <span class="icon iconfont" data-icon="&#xe648;">&#xe648;</span>
    </li>
    <li>
    <span class="icon iconfont" data-icon="&#xe649;">&#xe649;</span>
    </li>
    <li>
    <span class="icon iconfont" data-icon="&#xe64a;">&#xe64a;</span>
    </li>
    <li>
    <span class="icon iconfont" data-icon="&#xe64b;">&#xe64b;</span>
    </li>
    <li>
    <span class="icon iconfont" data-icon="&#xe64c;">&#xe64c;</span>
    </li>
    <li>
    <span class="icon iconfont" data-icon="&#xe64d;">&#xe64d;</span>
    </li>
    <li>
    <span class="icon iconfont" data-icon="&#xe64e;">&#xe64e;</span>
    </li>
    <li>
    <span class="icon iconfont" data-icon="&#xe64f;">&#xe64f;</span>
    </li>
    <li>
    <span class="icon iconfont" data-icon="&#xe650;">&#xe650;</span>
    </li>
    <li>
    <span class="icon iconfont" data-icon="&#xe651;">&#xe651;</span>
    </li>
    <li>
    <span class="icon iconfont" data-icon="&#xe652;">&#xe652;</span>
    </li>
    <li>
    <span class="icon iconfont" data-icon="&#xe653;">&#xe653;</span>
    </li>
    <li>
    <span class="icon iconfont" data-icon="&#xe654;">&#xe654;</span>
    </li>
    <li>
    <span class="icon iconfont" data-icon="&#xe655;">&#xe655;</span>
    </li>
    <li>
    <span class="icon iconfont" data-icon="&#xe656;">&#xe656;</span>
    </li>
    <li>
    <span class="icon iconfont" data-icon="&#xe657;">&#xe657;</span>
    </li>
    <li>
    <span class="icon iconfont" data-icon="&#xe658;">&#xe658;</span>
    </li>
    <li>
    <span class="icon iconfont" data-icon="&#xe659;">&#xe659;</span>
    </li>
    <li>
    <span class="icon iconfont" data-icon="&#xe65a;">&#xe65a;</span>
    </li>
    <li>
    <span class="icon iconfont" data-icon="&#xe65b;">&#xe65b;</span>
    </li>
    <li>
    <span class="icon iconfont" data-icon="&#xe65c;">&#xe65c;</span>
    </li>
    <li>
    <span class="icon iconfont" data-icon="&#xe65d;">&#xe65d;</span>
    </li>
    <li>
    <span class="icon iconfont" data-icon="&#xe65e;">&#xe65e;</span>
    </li>
    <li>
    <span class="icon iconfont" data-icon="&#xe65f;">&#xe65f;</span>
    </li>
    <li>
    <span class="icon iconfont" data-icon="&#xe660;">&#xe660;</span>
    </li>
    <li>
    <span class="icon iconfont" data-icon="&#xe661;">&#xe661;</span>
    </li>
    <li>
    <span class="icon iconfont" data-icon="&#xe662;">&#xe662;</span>
    </li>
    <li>
    <span class="icon iconfont" data-icon="&#xe663;">&#xe663;</span>
    </li>
    <li>
    <span class="icon iconfont" data-icon="&#xe664;">&#xe664;</span>
    </li>
    <li>
    <span class="icon iconfont" data-icon="&#xe665;">&#xe665;</span>
    </li>
    <li>
    <span class="icon iconfont" data-icon="&#xe666;">&#xe666;</span>
    </li>
    <li>
    <span class="icon iconfont" data-icon="&#xe667;">&#xe667;</span>
    </li>
    <li>
    <span class="icon iconfont" data-icon="&#xe668;">&#xe668;</span>
    </li>
    <li>
    <span class="icon iconfont" data-icon="&#xe669;">&#xe669;</span>
    </li>
    <li>
    <span class="icon iconfont" data-icon="&#xe66a;">&#xe66a;</span>
    </li>
    <li>
    <span class="icon iconfont" data-icon="&#xe66b;">&#xe66b;</span>
    </li>
    <li>
    <span class="icon iconfont" data-icon="&#xe66c;">&#xe66c;</span>
    </li>
    <li>
    <span class="icon iconfont" data-icon="&#xe66d;">&#xe66d;</span>
    </li>
    <li>
    <span class="icon iconfont" data-icon="&#xe66e;">&#xe66e;</span>
    </li>
    <li>
    <span class="icon iconfont" data-icon="&#xe66f;">&#xe66f;</span>
    </li>
    <li>
    <span class="icon iconfont" data-icon="&#xe670;">&#xe670;</span>
    </li>
    <li>
    <span class="icon iconfont" data-icon="&#xe671;">&#xe671;</span>
    </li>
    <li>
    <span class="icon iconfont" data-icon="&#xe672;">&#xe672;</span>
    </li>
    </ul>
    </div>
    </div>
</template>
<script>
export default {
  name: 'iconcontainer',
  data () {
    return {
    }
  },
  methods: {
    clickul (ele) {
      if (ele.target && ele.target.nodeName === 'SPAN') {
        this.$emit('handleicon', ele)
      }
    },
    invokeaction: function (mname) {
      this.$emit('invokemenu', mname)
    }
  }
}
</script>
<style lang="stylus" scoped>
  .iconcontainer
    width 100%
    display flex
    padding .18rem
    // border 1px solid #cdcdcd
    border-bottom none
    box-sizing border-box
    .wrapper
      width 100%
      border 1px solid #cdcdcd
      ul
        width 100%
        padding 0
        margin 0
        display flex
        flex-flow wrap
        padding .18rem 0
        li
          list-style none
          // padding .1rem .28rem
          color #cdcdcd
          font-size .28rem
          // border 1px solid #cdcdcd
          margin .1rem
          &:hover
            color #212529
            // border 1px solid #212529
            cursor pointer

</style>



// WEBPACK FOOTER //
// src/components/common/IconContainer.vue